import { useIsNative } from './hooks/useIsNative.tsx';

export const IfNative: React.FC<{children: React.ReactNode}> = ({ children }) => {

    const isNative = useIsNative();

    return isNative ? <>{children}</> : null;
};
